import { useState } from "react";
import { toast } from "react-toastify";

import { copyToClipboard } from "../../shared/utils";
import "../../shared/style/typography.scss";
import "../../shared/style/colors.scss";

import Button from "../UserInput/Buttons/Button";
import Heading from "../Typography/Heading";
import CreateOrUpdateSurveyCollectorDialog from "../Dialogs/CreateOrUpdateSurveyCollectorDialog";

/**
 *
 * @param {object} props
 * @param {(link: object) => void} props.onLinkGenerated Callback function to handle link generation
 */
const SurveyLinkGenerator = ({ onLinkGenerated }) => {
    const [isGenerateLinkModalOpen, setIsGenerateLinkModalOpen] = useState(false);

    function closeGenerateLinkModal() {
        setIsGenerateLinkModalOpen(false);
    }

    return (
        <>
            <div>
                <div className="flex items-center space-x-4">
                    <Heading style={{ marginBottom: "8px" }}>External surveys</Heading>
                </div>
                <div>
                    <div className="mb-5 text-[#455468]">Public link of your assessment</div>

                    <Button
                        size="xs"
                        handleOnClick={() => {
                            setIsGenerateLinkModalOpen(true);
                        }}
                    >
                        Create Collector
                    </Button>
                </div>
            </div>

            <CreateOrUpdateSurveyCollectorDialog
                title="Create collector"
                isOpen={isGenerateLinkModalOpen}
                onCollectorCreated={(createdCollector) => {
                    onLinkGenerated(createdCollector);

                    copyToClipboard(
                        window.location.protocol + "//" + window.location.host + "/survey/" + createdCollector.link_key,
                    );
                    toast.success("Survey link copied to clipboard");
                }}
                onClose={closeGenerateLinkModal}
                saveButtonText="Create"
            />
        </>
    );
};

export default SurveyLinkGenerator;
